import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from 'projects/authentication/_services/account.service';
import { ContentcmsService } from 'projects/authentication/_services/contentcms.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalService } from 'src/app/_core/global.service';
import { BehaviorService } from 'src/app/_core/_services/behavior.service';
import { ContentService } from 'src/app/_core/_services/content.service';
import { EventsService } from 'src/app/_core/_services/events.service';

@Component({
  selector: 'app-voucher',
  templateUrl: './voucher.component.html',
  styleUrls: ['./voucher.component.scss']
})
export class VoucherComponent implements OnInit {

  public User$: any = {};
  public UserCredits$: number;

  public Voucher: any;
  public Offers: any;
  public Stock: any;
  public OutherGames: any[];

  public alreadyLiked: boolean = false;
  private favoVouchId: number;

  public selectedVoucher: any;
  private UserSubscribed: boolean;

  public loading_: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private contSvc: ContentcmsService,
    public global: GlobalService,
    private beh: BehaviorService,
    private accountSvc: AccountService,
    private uparSvc: ContentService,
    private event: EventsService
  ) {
    this.beh.UserAccount.subscribe(u => { this.User$ = u });
    this.beh.UserWallet.subscribe(w => { this.UserCredits$ = w.total || 0 });

    this.route.params.subscribe(params => { !!params.voucherId && this.loadVoucherInfo(params.voucherId) });
    this.beh.UserSubscription.subscribe(userSub => { this.UserSubscribed = !!userSub?.subscriptions?.length });

  }

  ngOnInit(): void {
    this.event.eventStart({ eventType: 'VOUCHER_PAGE_ACCESS', eventCategory: 'ACCESS' });
  }

  private _subs = new Subject();
  ngOnDestroy() {
    this._subs.next();
    this._subs.complete();
  }

  private loadVoucherInfo(voucherID) {
    this.Voucher = null;
    this.contSvc.getContentDetail(voucherID).pipe(takeUntil(this._subs)).subscribe(voucher => {
      this.Voucher = this.global.entitysToPlain([voucher || {}])[0];
      !!this.User$.id && !!this.Voucher?.id && this.favouriteCheck();
      !!this.Voucher?.id && this.loadStock();
      !!this.Voucher?.id && this.loadOffers();
      this.loadOtherGames();
      location.hash == '#howtouse' && setTimeout(() => { this.gotoInfo(false) }, 1000);

      /* ADD target Blank to all <a> inside #howtouse */
      window.onload = function () {
        for (let i of document.querySelectorAll('#howtouse a') as any) { i.setAttribute('target', '_blank') }
      }
    }, () => {
      this.Voucher = {};
      this.beh.popup.next({ pop: 'error-generic' });
    });
  }

  private favouriteCheck() {
    this.accountSvc.checkFavourites({ contentId: this.Voucher.id, source: 'CMS' }).pipe(takeUntil(this._subs)).subscribe(check => {
      this.alreadyLiked = check?.added;
      this.favoVouchId = check?.favouriteId;
    }, () => { this.alreadyLiked = false; });
  }

  private loadOffers() {
    this.contSvc.getContentRefence(this.Voucher.id, 'offer', { orderBy: 'sortField', order: 'ASC' }).pipe(takeUntil(this._subs)).subscribe(reff => {
      this.Offers = this.global.entitysToPlain(reff?.list || []) || [];
    }, () => { this.Offers = [] });
  }

  private loadStock() {
    this.Stock = null;
    this.uparSvc.stockCheck({ voucherId: this.Voucher.id }).pipe(takeUntil(this._subs)).subscribe(stock => {
      this.Stock = stock?.offersStock || {};
    }, () => {
      this.Stock = {};
      this.beh.popup.next({ pop: 'error-generic' });
    });
  }

  private loadOtherGames() {
    if (this.beh.contentCallResp.value) {
      this.OutherGames = this.beh.contentCallResp.value;
    } else {
      this.contSvc.getContent('content', { useCache: true, count: 6, withReferences: false }).pipe(takeUntil(this._subs)).subscribe(res => {
        this.OutherGames = this.global.entitysToPlain(res?.list || []);
        this.beh.contentCallResp.next(this.OutherGames);
        // console.debug(this.OutherGames);
      }, () => { this.OutherGames = [] });
    }
  }

  public gotoInfo(info: boolean = true) {
    let value = document.getElementById(info ? 'voucherInfo' : 'howtouse')?.offsetTop - 55;
    window.scrollTo({ top: value, behavior: 'smooth' });
  }

  public makeFavourite() {
    this.alreadyLiked = true;

    this.accountSvc.addFavourites({
      favourites: [{
        source: 'CMS',
        contentType: this.Voucher.type,
        contentId: this.Voucher.id,
        contentCategory: this.Voucher.category
      }]
    }).pipe(takeUntil(this._subs)).subscribe(added => { added.responseCode != 'SUCCESS' && (this.alreadyLiked = true) });
  }

  public doDislike() {
    this.accountSvc.removeFavourites({ favourites: [{ id: this.favoVouchId }] }).pipe(takeUntil(this._subs)).subscribe(removed => {
      removed?.responseCode == 'SUCCESS' && (this.alreadyLiked = false);
    });
  }

  public doBuyVoucher() {
    if (!!this.selectedVoucher) {
      this.event.eventStart({ eventType: 'PURCHASE_CTA_CLICK', eventCategory: 'CLICK' });
      if (!this.User$.id) {
        this.event.eventStart({ eventType: 'PURCHASE_CTA_CLICK_ERROR', eventCategory: 'CLICK' });
        this.beh.popup.next({ pop: 'access-account' });
      } else {
        if (+this.selectedVoucher.ups_value > this.UserCredits$) {
          this.event.eventStart({ eventType: 'PURCHASE_CTA_CLICK_ERROR', eventCategory: 'CLICK' });
          this.beh.popup.next({ pop: this.UserSubscribed ? 'no-credits' : 'no-credits-subscription' });
        } else {
          this.event.eventStart({ eventType: 'PURCHASE_CTA_CLICK_SUCCESS', eventCategory: 'CLICK' });
          this.beh.voucherData.next({ selected: this.selectedVoucher, voucher: this.Voucher });
          this.router.navigate(['voucher', this.Voucher.id, 'buy']);
        }
      }
    }
  }

}
